<template>
  <ul>
    <li class="d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover" v-for="item in items" :key="item.stationCode" @click="liClickEvent($event,item)" :ref="item.stationCode+'Ref'">
      <div class="d-table-cell v-a-middle h-100-p w-64">
        <span class="d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none b" style="background-color:#ecf3fa; border-color:#a0caf7;"><img class="m-t-5 w-24" src="@/assets/images/im/org_icon.svg"></span>
      </div>
      <div class="p-relative d-table-cell v-a-middle h-100-p">
        <p class="t-ellipsis l-h-1-6-em" style="white-space:inherit;" :style="{width:listWidth-40+'px'}">{{item.stationName}} <span class="f-s-12">{{item.stationCode}}</span></p>
        <img class="p-absolute top-27 right-10 user-select-none" src="@/assets/images/im/arrow-right.svg" width="12">
      </div>
      <im-popover :target-parent-ref="$refs" :target-ref-name="item.stationCode+'Ref'" :ref="item.stationCode+'PointRef'" z-index="20">
        <div style="text-align:center; padding:5px;" v-show="item.loading"><img src="@/assets/images/im/loading_button.gif" width="16"></div>
        <ul class="o-auto" style="max-height: 300px;">
          <li class="f-s-12 t-a-center p-y-5 c-g-500" v-if="item.children.length===0 && !item.loading">暂无数据</li>
          <li class="p-x-10 p-y-5 cursor-default b-b b-c-g-100 bg-g-50-hover" v-for="(itemb,indexb) in item.children" :key="itemb.userCode" :class="{'b-b-w-0':indexb===item.children.length-1}" @click="itemClickEvent(itemb)">{{itemb.userName}} {{itemb.userCode}} {{getUserRole(itemb)}}</li>
        </ul>
      </im-popover>
    </li>
  </ul>
</template>
<script>
export default {
  
  props: {
    items: {
      type: Array,
      default: []
    },
    orgcode: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 250
    }
  },
  // 设置 宽度,
  data: function () {
    return {
      listWidth: 148
    };
  },
  components: {
    'im-popover': () => import('./component/im-popover.vue')
  },
  methods: {
    // 用户信息
    getUserRole: function (item) {
      var str = '';
      str += item.role && item.role !== '无' ? ' ' + item.role : '';
      return str;
    },
    liClickEvent: function (event, item) {
      if (item.children.length > 0) return;
      var currentTarget = event.currentTarget;
      item.loading = true;
      var $this = this;
      axiosHttpIm.post('/netEasyIM/getIMUserInfo', {
        type: 'stationCode',
        loginStationCode: this.orgcode,
        value: item.stationCode,
        pageNum: 1,
        pageSize: 100
      }).then(
        function (response) {
          var data = response.resultData.data || {};
          item.children = data.stationList || [];
          item.loading = false;
          $this.$nextTick(function () {
            $this.$refs[item.stationCode + 'PointRef'][0].coorHandler(event, currentTarget);
          });
        },
        function (error) {
          item.loading = false;
        }
      );
    },
    // 点击联系人
    itemClickEvent: function (item) {
      this.$emit('createSession', item);
      // this.$emit('destroy');
      this.$refs[item.stationCode + 'PointRef'][0].destroy();
    },
  },
  watch: {
    width: function (val) {
      this.listWidth = val - 65;
    }
  }
}
</script>
